export {default as Coins1} from './Coins1';
export {default as Coins2} from './Coins2';
export {default as Coins3} from './Coins3';
export {default as Coins4} from './Coins4';
export * from './EWalletIcon';
export * from './MasterCardIcon';
export * from './VisaIcon';
export {default as FawryLogo} from './FawryLogo.png';
export {default as ValULogo} from './valU-logo.webp';
